export function split(input: string, separator: string) {
  const parts = input.split(separator)

  return parts
}
